<template>
    <div class="flex h-auto bg-gray-900 text-white">
      <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700">
        <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Vultric Logo" class="h-20">
        </div>
        <Navbar></Navbar>
      </aside>
  
      <div class="flex-1 flex flex-col">
        <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md bg-gradient-to-b from-gray-800 to-gray-900 border-b border-gray-700">
          <h2 class="text-xl font-semibold">Private Networking</h2>
        </header>
  
        <main class="p-6 flex-1">
            <div class="p-6 bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 
            rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition">
            <h3 class="text-lg font-semibold mb-4">Manage Private Networks</h3>
  
            <!-- Create Private Network Form -->
            <div class="mb-4 flex space-x-2">
              <input v-model="newNetwork.name" placeholder="Network Name" class="p-2 rounded bg-gray-700 text-white w-1/3"/>
              <input v-model="newNetwork.cidr" placeholder="CIDR (e.g., 192.168.1.0/24)" class="p-2 rounded bg-gray-700 text-white w-1/3"/>
              <button @click="createNetwork" class="bg-green-500 px-4 py-2 rounded">Create</button>
            </div>
  
            <!-- Private Networks Table -->
            <table class="w-full text-left border-collapse">
              <thead>
                <tr class="bg-gray-700">
                  <th class="p-3">Name</th>
                  <th class="p-3">CIDR</th>
                  <th class="p-3">Created At</th>
                  <th class="p-3">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="network in networks" :key="network.id" class="border-b border-gray-600">
                  <td class="p-3">{{ network.name }}</td>
                  <td class="p-3">{{ network.cidr }}</td>
                  <td class="p-3">{{ formatDate(network.created_at) }}</td>
                  <td class="p-3">
                    <button @click="deleteNetwork(network.id)" class="bg-red-500 px-2 py-1 rounded">Delete</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from '@/components/nav.vue';
  import axios from 'axios';
  
  export default {
    name: "PrivateNetworking",
    components: { Navbar },
    data() {
      return {
        networks: [],
        newNetwork: { name: "", cidr: "" }
      };
    },
    methods: {
      async fetchNetworks() {
        try {
          const res = await axios.get('https://api.syniac.com:3000/api/private-network/get', { withCredentials: true });
          this.networks = res.data["0"];
        } catch (error) {
          console.error("Error fetching networks:", error);
        }
      },
      async createNetwork() {
        if (!this.newNetwork.name || !this.newNetwork.cidr) return;
        try {
          const res = await axios.post('https://api.syniac.com:3000/api/private-network/add', this.newNetwork, { withCredentials: true });
          this.networks.push(res.data);
          this.newNetwork.name = "";
          this.newNetwork.cidr = "";
        } catch (error) {
          console.error("Error creating network:", error);
        }
      },
      async deleteNetwork(id) {
        if (!confirm("Are you sure you want to delete this network?")) return;
        try {
          await axios.delete(`https://api.syniac.com:3000/api/private-network/delete/${id}`, { withCredentials: true });
          this.networks = this.networks.filter(network => network.id !== id);
        } catch (error) {
          console.error("Error deleting network:", error);
        }
      },
      formatDate(dateString) {
        return new Date(dateString).toLocaleString();
      }
    },
    mounted() {
      this.fetchNetworks();
    }
  };
  </script>
  
